<template>
  <div class="home-skeleton">
    <div class="item" v-for="i in 4" :key="i" :style="{ backgroundColor: bg }">
      <shSkeleton bg="#e4e4e4" width="348px" height="224px" animated />
      <shSkeleton bg="#e4e4e4" width="335px" height="35px" animated />
      <shSkeleton bg="#e4e4e4" width="200px" height="22px" animated />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  /* width: 350px;
  height: 309px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; */
  .item {
    width: 350px;
    margin-bottom: 15px;
    .sh-skeleton ~ .sh-skeleton {
      display: block;
      margin: 10px auto 0;
    }
  }
}
</style>
